import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Checkbox, FormControlLabel } from '@material-ui/core';

// HOOKS
import useActions from '@/hooks/useActions';

// STORE
import { UserActions } from '@/store/actions';

const CardPaymentsAgreements = ({ label }) => {
  const { user, loadingUpdateSettings } = useSelector(({ auth, user: userStore }) => ({
    user: auth.user || {},
    loadingUpdateSettings: userStore.loadings.updateSettings,
  }));

  const [userUpdateSettings] = useActions([
    data => UserActions.userUpdateSettings.action({ data }),
  ]);

  const handleChange = e => {
    const isChecked = e.target.checked;

    userUpdateSettings({ card_payments_allowed: isChecked });
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          name="checkedC"
          checked={user.card_payments_allowed || false}
          disabled={loadingUpdateSettings}
        />
      }
      label={label}
      onChange={handleChange}
    />
  );
};

CardPaymentsAgreements.propTypes = {
  label: PropTypes.string.isRequired,
};

export default React.memo(CardPaymentsAgreements);
